import { useState, useEffect, useCallback } from 'react';
import { hasTermAgreed, setTermAsAgreed } from '@/lib/term';
import { apiFetch } from '@/lib/api';

export function useTermsAgreed() {
  const [hasSigned, setHasSigned] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const check = useCallback(async () => {
    if (hasTermAgreed()) {
      setHasSigned(true);
      setIsLoading(false);
      return;
    }
    try {
      const res = await apiFetch('/terms/signed', 'GET');
      if (res.ok) {
        const data = await res.json();
        if (data) {
          setTermAsAgreed();
          setHasSigned(true);
        } else {
          setHasSigned(false);
        }
      } else {
        setHasSigned(true);
      }
    } catch {
      setHasSigned(true);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    check();
  }, [check]);

  return { hasSigned, isLoading, refetch: check };
}
